import React, { RefObject } from 'react';

import { useSvgIcon } from 'u9/hooks';

import * as Styled from './Button.styles';

export const validButtonThemes = ['red', 'black', 'outlined'] as const;
export const validIcons = ['arrowLeft', 'roadsSignature'] as const;

export interface ButtonProps {
  text: string;
  isActive?: boolean;
  icon?: '' | string | typeof validIcons[number];
  type?: '' | typeof validButtonThemes[number];
  accessibilityLabel?: string;
  ariaCurrent?: boolean;
  ariaHidden?: boolean;
  tabIndex?: number;
  onClick: (e) => void;
  elementRef?: RefObject<any>;
}

const defaultProps: Partial<ButtonProps> = {
  type: '',
};

const Button: React.FC<ButtonProps> = ({
  text,
  isActive,
  icon,
  type,
  onClick,
  ariaCurrent,
  ariaHidden,
  tabIndex,
  elementRef,
}) => {
  const { SvgIcon } = useSvgIcon(icon);
  return (
    <Styled.Wrapper
      isActive={isActive}
      onClick={onClick}
      variant={type}
      aria-current={ariaCurrent}
      aria-hidden={ariaHidden}
      tabIndex={tabIndex}
      ref={elementRef}
    >
      {icon && (
        <Styled.IconWrapper>
          <SvgIcon />
        </Styled.IconWrapper>
      )}
      <Styled.Text dangerouslySetInnerHTML={{ __html: text }} />
    </Styled.Wrapper>
  );
};

Button.defaultProps = defaultProps;

export default Button;
